import ContentManager from "../ContentManager";

const LeadershipAdmin = () => (
  <ContentManager type="leader" title="Leadership"
    description="Management team shown on the About page. Replace photographs via the image field (browse the Media Library). Save & Publish to go live." />
);

export default LeadershipAdmin;
